module.exports = __webpack_public_path__ + "img/9791185359045.0e4c314e.jpg";